import React, { useEffect, useRef, useState } from "react";
import "../styles/voiceoverWrapper.scss";
import { getAvailableVoices, speakMessage, stopSpeaking } from "./TextToSpeech";
import { IoClose } from "react-icons/io5";
import { getOS } from "./getOS";

const VoiceoverWrapper = ({ handleAskQuestionWrapper, handleAskQuestion }) => {
  React.useEffect(() => {
    const handleScroll = (event) => {
      event.preventDefault();
      window.scrollTo(0, 0);
    };

    document.body.style.overflow = "hidden";
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.body.style.overflow = "auto";
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [isListening, setIsListening] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [text, setText] = useState("");
  const [voices, setVoices] = useState([]);
  const [recognition, setRecognition] = useState(null);
  const latestText = useRef("");
  const latestResponseAns = useRef("");
  const [selectedVoice, setSelectedVoice] = useState(null);

  useEffect(() => {
    if ("SpeechRecognition" in window || "webkitSpeechRecognition" in window) {
      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      const recognitionInstance = new SpeechRecognition();

      recognitionInstance.continuous = false; // Stop automatically after speech ends
      recognitionInstance.interimResults = true;
      recognitionInstance.lang = "en-IN"; // Set language if needed

      recognitionInstance.onresult = (event) => {
        const transcript = Array.from(event.results)
          .map((result) => result[0])
          .map((result) => result.transcript)
          .join("");

        setText(transcript);
        latestText.current = transcript;
      };

      recognitionInstance.onerror = (event) => {
        console.error("Speech recognition error", event.error);
        setIsListening(false);
      };

      recognitionInstance.onspeechend = async () => {
        console.log("User stopped speaking.");
        recognitionInstance.stop();
        setIsListening(false);
      };

      setRecognition(recognitionInstance);
    }
  }, [text]);

  const toggleListening = () => {
    if (isListening) {
      recognition.stop();
      setIsListening(false);
    } else {
      recognition.start();
      setIsListening(true);
    }
  };

  useEffect(() => {
    const getResponse = async () => {
      const trimmedText = latestText.current.trim(); // Get the latest text
      if (trimmedText) {
        const response = await handleAskQuestion(trimmedText);
        const filteredAns = response?.answer.replace(/\*\*/g, '');
        console.log("filteredAns", filteredAns);
        latestResponseAns.current = filteredAns;
          speakMessage(
            filteredAns || "Oops! Looks like Lyra's cloud is taking a quick break. We're on it and things will be back to normal soon. Thanks for bearing with us!",
            setIsListening,
            isListening,
            recognition,
            selectedVoice,
            setIsSpeaking
          );
        if (response?.answer) {
          response.answer = null; // Reset the answer in the response object
        }
        setText(""); // Clear the text after sending it
        latestText.current = ""; // Reset latestText as well
        
        console.log("latestText.current after sending:", latestText.current);
      }
    };

    if (latestText.current && !isListening) {
      getResponse();
    }
  }, [handleAskQuestion, isListening, recognition, selectedVoice]);

  useEffect(() => {
    getAvailableVoices().then(setVoices);
  }, []);

  const closeVoiceResponseWrapper = ()=> {
    stopSpeaking(setIsSpeaking);
    handleAskQuestionWrapper();
  }
  
  console.log(getOS()); // "Windows", "Android", or "iOS"

  useEffect(() => {
    if( getOS() === "Windows") {
      const soundName = ["Microsoft Heera - English (India)", "Microsoft Hazel", "Microsoft Zira", "Microsoft Kalpana", ]
      let selectedVoice = voices.find((voice) => soundName.includes(voice.name));
      if(!selectedVoice){
        selectedVoice = voices.length > 0 ? voices[0] : null;
      }
      setSelectedVoice(selectedVoice?.name)
    } else if( getOS() === "Android") {
      const soundName = ["Assamese India", "English India", "Hindi India"];
      let selectedVoice = voices.find((voice) => soundName.includes(voice.name));
      if(!selectedVoice){
        selectedVoice = voices.length > 0 ? voices[0] : null;
      }
      setSelectedVoice(selectedVoice?.name)
    } else if( getOS() === "iOS") {
      const soundName = ["Meena", "Samantha", "Tessa", "Rishi"];
      let selectedVoice = voices.find((voice) => soundName.includes(voice.name));
      if(!selectedVoice){
        selectedVoice = voices.length > 0 ? voices[0] : null;
      }
      setSelectedVoice(selectedVoice?.name)
    } else {
      setSelectedVoice(voices[0]?.name || null); // Default to the first voice if none is selected
    }
  }, [voices]);

  console.log("selectedVoice", selectedVoice)

  return (
    <div className="voice_over_wrapper">
      <div className="absolute_close_btn" onClick={()=> closeVoiceResponseWrapper()}><IoClose /></div>
      <div className="mic_text">
        <p>{text ? text : isSpeaking ? "🔊 Lyra is speaking..." : "Tap the mic icon below and start speaking clearly without long pauses. Your words will appear here as you speak..."}</p>
        {/* <select onChange={(e) => setSelectedVoice(e.target.value)}>
          {voices.map((voice) => (
            <option key={voice.name} value={voice.name}>
              {voice.name} ({voice.lang})
            </option>
          ))}
        </select> */}
      </div>
      <div className="mic_icon" onClick={toggleListening}>
        {!isListening ? (
          <img src="./icons/mic-inactive.png" alt="icon" />
        ) : (
          <img src="./icons/mic-active.png" alt="icon" />
        )}
      </div>
      {isListening && (
        <div className="mic_wave">
          <span></span>
          <span></span>
          <span></span>
        </div>
      )}
    </div>
  );
};

export default VoiceoverWrapper;
